import { SEO, PageLayout, FastTrackHero, Satisfaction, CourseCarousel, StudentSuccess } from "../components";
import { INST_DATA } from "../data/instructor";
import InstructorsBlock from "../components/instructorsBlock";
import { useDispatch } from "react-redux";
import { getAnnouncement, getRegions, getCourseSchedules, getTestimonials, getSuccessStory, getCourses, getCourseCarouselData } from "../redux/action";
import { useEffect } from "react";
import ReactPlayer from "react-player";

const FastTrack = () => {
    const dispatch = useDispatch();
   useEffect(() => {
    dispatch(getAnnouncement())
    dispatch(getRegions())
    dispatch(getTestimonials())
    dispatch(getCourses())
    dispatch(getCourseSchedules())
    dispatch(getSuccessStory())
    dispatch(getCourses())
    dispatch(getCourseCarouselData())
  }, [])

 return (
   <>
     <SEO
       url="/fast-track"
       openGraphType="website"
       schemaType="website"
       title= "Fast Track Page"
       description="We help you transition into tech seamlessly."
     />
     <PageLayout>
       <div className="bg-[#FCFCF5] w-full">
         <FastTrackHero/>
       </div>
       <Satisfaction/>
       <StudentSuccess/>
       {/* Video Testimonials Section */}
       <section style={{padding: '2rem 0'}}>
         <h2 style={{fontSize: '2rem', fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center'}}>Video Testimonials</h2>
         <div style={{display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center'}}>
           <div style={{maxWidth: 400, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
             <h3 style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Video 1 - Jay's Testimonial</h3>
             <div style={{width: '100%', aspectRatio: '16/9', background: '#000', borderRadius: 8, overflow: 'hidden'}}>
               <ReactPlayer url="https://theskillgarage.wistia.com/medias/9er8ovray7" controls width="100%" height="100%"/>
             </div>
           </div>
           <div style={{maxWidth: 400, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
             <h3 style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Video 2 - Mike's Testimonial</h3>
             <div style={{width: '100%', aspectRatio: '16/9', background: '#000', borderRadius: 8, overflow: 'hidden'}}>
               <ReactPlayer url="https://theskillgarage.wistia.com/medias/7h440bvwuv" controls width="100%" height="100%"/>
             </div>
           </div>
           <div style={{maxWidth: 400, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
             <h3 style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Video 3 - Nosa's Testimonial</h3>
             <div style={{width: '100%', aspectRatio: '16/9', background: '#000', borderRadius: 8, overflow: 'hidden'}}>
               <ReactPlayer url="https://theskillgarage.wistia.com/medias/7lgmpp1btu" controls width="100%" height="100%"/>
             </div>
           </div>
         </div>
       </section>
       <InstructorsBlock items={INST_DATA}/>
       <Satisfaction satisfaction/>
       {/* <CourseCarousel/> */}
     </PageLayout>
   </>
 )
}

export default FastTrack;